module.exports = __webpack_public_path__ + "img/project_e7.dd3fc454.jpg";